<app-film
  name="cinema"
  anchor="cinema"
  label="Ultimate Cinema Seating — multiplex recliner tour"
  [chapters]="chapters"
  [loader]="loader"
  [actions]="actions"
/>
